module.exports = __webpack_public_path__ + "img/icon-question-nps.dff9bb04.svg";